import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";
import type { StockLevels } from "@retailer/svelte/CartWidget/v2/Services/CartItemRequestService";

interface CartProductEntityParams {
  productId: number;
  productLineId: number;
  distributor_id: number;
  order_group_id: number;
  order_id: number;
  inventory_id: number;
  unitQuantity: number;
  caseQuantity: number;
  stockLevel: StockLevels;
}
export class CartProductEntity extends BaseEntityClass {
  productId: number;
  productLineId: number;
  distributor_id: number;
  order_group_id: number;
  order_id: number;
  inventory_id: number;
  unitQuantity: number;
  caseQuantity: number;
  stockLevel: StockLevels;
  constructor(params: CartProductEntityParams) {
    super();
    this.type = "cart_product";
    this.entity_version = 2;
    this.productId = params.productId;
    this.productLineId = params.productLineId;
    this.distributor_id = params.distributor_id;
    this.order_group_id = params.order_group_id;
    this.order_id = params.order_id;
    this.inventory_id = params.inventory_id;
    this.unitQuantity = params.unitQuantity;
    this.caseQuantity = params.caseQuantity;
    this.stockLevel = params.stockLevel;
  }
}
